<script lang="ts">
    import { createEventDispatcher } from "svelte";

    import Tooltip from "./Tooltip.svelte";
    import { TooltipPosition } from "./types";

    export let position: TooltipPosition = "top";
    export let theme: "dark" | "light" = "dark";
    export let active = false;
    export let arrow = false;
    export let followCursor = false;
    export let maxWidth = "200px";
    export let distance = 8;
    export let isVisible = false;

    const dispatch = createEventDispatcher();

    let tooltipContainer: HTMLDivElement | null = null;

    const showTooltip = (): void => {
        isVisible = true;
        dispatch("toggle", isVisible);
    };

    const hideTooltip = (): void => {
        isVisible = false;
        dispatch("toggle", isVisible);
    };

    const handleMouseMove = (e: MouseEvent): void => {
        if (followCursor) {
            const tooltipContent = tooltipContainer?.querySelector(
                ".tooltip-content"
            ) as HTMLDivElement;

            if (!tooltipContent) return;

            tooltipContent.style.top = `${e.clientY + distance}px`;
            tooltipContent.style.left = `${e.clientX + distance}px`;
        }
    };
</script>

<div
    class="gw-tooltip-container"
    on:mouseenter={showTooltip}
    on:mouseleave={hideTooltip}
    on:mousemove={handleMouseMove}
    bind:this={tooltipContainer}
>
    <slot />
    <Tooltip
        active={isVisible || active}
        {position}
        {theme}
        {arrow}
        {maxWidth}
        {followCursor}
        {distance}
    >
        <slot name="content" />
    </Tooltip>
</div>

<style>
    .gw-tooltip-container {
        position: relative;
    }
</style>
